import React from 'react'
import { Typography } from '@telavita-core/react-design-kit'

import { Option } from '../../types/option'

import * as S from './styles'
import { Controller, useFormContext } from 'react-hook-form'
import { CustomRadioButton } from '../CustomRadioButton'
import { MedicalRecordFormData } from '../../medicalRecordSchema'
import { RadioButtonErrorWrapper } from '../RadioButtonErrorWrapper'

const radioOptions: Option[] = [
  { id: 'patient-goal-action', name: 'Ação' },
  { id: 'patient-goal-pre-contemplation', name: 'Pré-contemplação' },
  { id: 'patient-goal-contemplation', name: 'Contemplação' },
  {
    id: 'patient-goal-planning-or-preparation',
    name: 'Planejamento ou preparação',
  },
  { id: 'patient-goal-maintenance-or-relapse', name: 'Manutenção ou recaída' },
]

export function PatientGoal(): JSX.Element {
  const {
    control,
    formState: { errors },
  } = useFormContext<MedicalRecordFormData>()

  const errorMessage = errors.patient_goal?.message

  return (
    <S.PatientGoalContainer>
      <Typography weight='bolder' variant='content2'>
        De acordo com sua avaliação, qual a motivação do paciente para seguir
        com o tratamento? *
      </Typography>
      <RadioButtonErrorWrapper errorMessage={errorMessage}>
        <S.RadioButtonOptions>
          {radioOptions.map((option) => (
            <Controller
              key={option.id}
              control={control}
              name='patient_goal'
              render={({ field }) => (
                <CustomRadioButton
                  {...field}
                  key={option.id}
                  id={option.id as string}
                  onChange={() => field.onChange(option.id)}
                  label={
                    <Typography variant='content2'>{option.name}</Typography>
                  }
                  hasError={!!errorMessage}
                />
              )}
            />
          ))}
        </S.RadioButtonOptions>
      </RadioButtonErrorWrapper>
    </S.PatientGoalContainer>
  )
}
